export const ITEMS = {
  DOOR: 'door',
  SHELF_DRAWER: 'shelf-drawer',
  DRAWER: 'drawer',
  SECTION: 'section',
  SECTION_SIDE_UNITS: 'section-side-units',
  SECTION_POSTS: 'section-posts',
  CABINET: 'cabinet',
  CLOTHES_RAIL: 'clothes-rail',
  SHELF: 'shelf',
  METAL_SHELF: 'metal-shelf',
  WIRE_SHELF: 'wire-shelf',
  FELT_SHELF: 'felt-shelf',
  BASKET: 'basket',
  UPRIGHT: 'upright',
  SHOE_SHELF: 'shoe-shelf',
  DRYING_RACK: 'drying-rack',
  TROUSER_HANGER: 'trouser-hanger',
  POST: 'post',
  PEGBOARD: 'pegboard',
  ADD_ON: 'add-on',
  DIVIDER: 'divider',
  WORKBENCH: 'workbench',
  TROLLEY: 'trolley',
  BOTTLE_RACK: 'bottle-rack',
  ITEM: 'item',
  CHEST: 'chest',
  TABLE: 'table',
  FRAME: 'frame',
  SHELVING_UNIT: 'shelving-unit',
  TOP_SHELF: 'top-shelf',
  BOX: 'box',
  BRACKET: 'bracket',
  MOUNTING_RAIL: 'mounting-rail',
  LEG: 'leg',
  COVER: 'cover',
  SIDEWALL: 'sidewall',
  DUMMY: 'dummy',
  SIDE_PANEL: 'side-panel',
  CROSS_BRACE: 'cross-brace',
  END_SHELF: 'end-shelf',
  SHELF_CLOTHES_RAIL: 'shelf-clothes-rail',
};

export const FILTERS = {
  SECTIONS: 'sections',
  INSERTS: 'inserts',
  PARTS: 'parts',
  UPRIGHTS: 'uprights',
  SHELVES_BASKETS: 'shelves-baskets',
  ACCESSORIES: 'accessories',
  TABLES: 'tables',
  MODULES: 'modules',
  FRAMES: 'frames',
  SHELVING_UNITS: 'shelving_units',
};

export const MISSING_PRODUCT_CATEGORIES = {
  SECTION: 'section',
  MOUNTING_RAIL_SHORT: 'mounting_rail_short',
  MOUNTING_RAIL_LONG: 'mounting_rail_long',
  SIDE_PANEL: 'side_panel',
  END_SHELF: 'end_shelf',
  MOUNTING_RAILS_SIDE_PANEL_END_SHELF_COLOR_MISMATCH:
    'mounting_rails_side_panel_end_shelf_color_mismatch',
  UPRIGHT: 'upright',
  BRACKET: 'bracket',
};

export const ART = 'ART';

export const RANGES = {
  BROR: 'BROR',
  IVAR: 'IVAR',
  JONAXEL: 'JONAXEL',
  BOAXEL: 'BOAXEL',
  AURDAL: 'AURDAL',
  ELVARLI: 'ELVARLI',
};

export const DIMENSIONS = {
  width: 'width',
  depth: 'depth',
  height: 'height',
};

export const UNITS = {
  mm: 'mm',
  cm: 'cm',
  dm: 'dm',
  m: 'm',
};

export const UNIT_CONVERSIONS = {
  [UNITS.mm]: 1,
  [UNITS.cm]: 10,
  [UNITS.dm]: 100,
  [UNITS.m]: 1000,
};

export const KEYS = {
  ENTER: 'Enter',
  BACKSPACE: 'backspace',
};

export const MS = 'MEASURE_VALUE';
export const TS = 'TIMES_SYMBOL';
export const SI = 'SI';

export const SCENE_VIEW_ID = 'scene-view';

export const ADD = 'ADD';
export const REMOVE = 'REMOVE';
export const KIOSK = 'kiosk';
